import { BuildProductQuoteResponse } from "@/types/api/quote";

export function calculatePlanTotalPrice(products: BuildProductQuoteResponse[]): number {
  let total = 0;

  products.forEach((product) => {
    if (product.type === "product") {
      total += product.product!.finalAmount;
    } else {
      total += product.group!.finalAmount;
    }
  });

  return total;
}
